import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { Text } from "sprout-ui-primitives";
import { PageBanner } from "@sprout/client-layout";
import { Button } from "sprout-ui-dom/dist/Button";
import { useSetItemsArchived, useSetItemsDeleted } from "@sprout/client-graphql";
import { useTopicPage } from "./TopicPageContext";
const TopicPagePageBanner = (props)=>{
    const { topic  } = props;
    const { archivedAt , deletedAt , isExplicitlyArchived , isExplicitlyDeleted , title , isRootTopic ,  } = topic;
    const { isOwnerOrAdmin , isOwner  } = useTopicPage();
    const text = title || `${isRootTopic ? "This tree" : "This branch"}`;
    const canUnarchive = isOwnerOrAdmin && !deletedAt;
    const canRestore = isRootTopic && isOwner || !isRootTopic && isOwnerOrAdmin;
    const snackbarOverwrite = isRootTopic ? "Tree" : "Branch";
    const setItemsArchived = useSetItemsArchived();
    const unarchiveTopic = useCallback(()=>{
        setItemsArchived({
            items: [
                topic
            ],
            isExplicitlyArchived: false,
            snackbarOverwrite: snackbarOverwrite
        });
    }, [
        setItemsArchived,
        snackbarOverwrite,
        topic
    ]);
    const setItemsDeleted = useSetItemsDeleted();
    const restoreTopic = useCallback(()=>{
        setItemsDeleted({
            items: [
                topic
            ],
            isExplicitlyDeleted: false,
            snackbarOverwrite: snackbarOverwrite
        });
    }, [
        setItemsDeleted,
        snackbarOverwrite,
        topic
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            archivedAt && !deletedAt && /*#__PURE__*/ _jsxs(PageBanner, {
                bg: "yellow.100",
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        as: "span",
                        lineHeight: "24px",
                        children: isExplicitlyArchived ? `${text} is archived` : `${text} is in an archived branch`
                    }),
                    isExplicitlyArchived && canUnarchive && /*#__PURE__*/ _jsx(Button, {
                        variant: "outline",
                        color: "primary",
                        onClick: unarchiveTopic,
                        children: "Unarchive"
                    })
                ]
            }),
            deletedAt && /*#__PURE__*/ _jsxs(PageBanner, {
                bg: "grey.200",
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        as: "span",
                        lineHeight: "24px",
                        children: isExplicitlyDeleted ? `${text} has been marked for deletion` : `${text} is in a branch marked for deletion`
                    }),
                    isExplicitlyDeleted && canRestore && /*#__PURE__*/ _jsx(Button, {
                        variant: "outline",
                        color: "primary",
                        onClick: restoreTopic,
                        children: "Restore"
                    })
                ]
            })
        ]
    });
};
export default TopicPagePageBanner;
